import {
  addAnimationEventListener,
  removeAnimationEventListener,
} from 'fitify-ui-onboarding/src/utils/animation-events'
import {
  type HTMLAttributes,
  type PropsWithChildren,
  useEffect,
  useState,
} from 'react'

import { FORM_ID } from 'components/GenderFunnel/Layout/Layout.Utils'
import {
  StyledContainer,
  StyledForm,
  StyledFormContainer,
} from 'components/GenderFunnel/Layout/LayoutContainer/LayoutContainer.Styled'

export type LayoutContainerProps = {
  form?: Pick<HTMLAttributes<HTMLFormElement>, 'onChange' | 'onSubmit'>
}

export const LayoutContainer = ({
  children,
  form,
}: PropsWithChildren<LayoutContainerProps>) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)

    const handlePageTransitionEvent = () => {
      setIsVisible(false)
    }

    addAnimationEventListener(handlePageTransitionEvent)

    return () => {
      removeAnimationEventListener(handlePageTransitionEvent)
    }
  }, [])

  if (form) {
    return (
      <StyledFormContainer $isVisible={isVisible}>
        <StyledForm
          id={FORM_ID}
          onChange={form.onChange}
          onSubmit={form.onSubmit}
        >
          {children}
        </StyledForm>
      </StyledFormContainer>
    )
  }
  return <StyledContainer $isVisible={isVisible}>{children}</StyledContainer>
}
